import { useParams } from 'react-router-dom';
import { TechRadarComponent } from '@backstage-community/plugin-tech-radar';
import { stringifyEntityRef } from '@backstage/catalog-model';
import { Page, Header, Content } from '@backstage/core-components';

/**
 * Renders a Tech Radar using a Catalog entity reference from the route params.
 * Route: /tech-radar/:namespace/:kind/:name
 */
export const EntityRadarPage = () => {
  const params = useParams();
  const namespace = params.namespace as string;
  const kind = params.kind as string;
  const name = params.name as string;

  const id = stringifyEntityRef({ kind, namespace, name });

  return (
    <Page themeId="tool">
      <Header title="Tech Radar" subtitle="Pick the recommended technologies for your projects" />
      <Content>
        <TechRadarComponent
          id={id}
          width={1450}
          height={1000}
          svgProps={{ style: { fontFamily: 'Arial, Helvetica' } }}
        />
      </Content>
    </Page>
  );
};
